import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "" }
const _hoisted_2 = {
  class: "w-100",
  style: {"margin":"0 auto"}
}
const _hoisted_3 = {
  key: 0,
  class: "mb-5"
}
const _hoisted_4 = {
  key: 1,
  class: "table align-middle fs-6 gy-5 h-100"
}
const _hoisted_5 = {
  key: 2,
  class: "w-100 px-10"
}
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 2 }
const _hoisted_8 = {
  key: 6,
  class: "h-500px"
}
const _hoisted_9 = { class: "w-100 h-100 d-flex justify-content-center align-items-center" }
const _hoisted_10 = { class: "text-center" }
const _hoisted_11 = {
  key: 0,
  class: "text-center"
}

import KycForm from "./KycForm.vue";
import AccountDetail from "./AccountDetail.vue";
import MsgPrompt from "@/core/plugins/MsgPrompt";
import ReadOnlyNotice from "./ReadOnlyNotice.vue";
import SimpleForm from "@/components/SimpleForm.vue";
import { computed, nextTick, provide, ref } from "vue";
import UserService from "../../users/services/UserService";
import { AccountRoleTypes } from "@/core/types/AccountInfos";
import PaymentMethodDetailForm from "./PaymentMethodDetailForm.vue";
import AccountCreate from "../../users/components/AccountCreate.vue";
import UserDocuments from "../../users/components/UserDocuments.vue";
import { ApplicationStatusType } from "@/core/types/ApplicationInfos";
import AccountService, { AccountWizardType } from "../services/AccountService";
import AccountInjectionKeys from "@/projects/tenant/modules/accounts/types/AccountInjectionKeys";
import OpenAccountForm from "@/projects/tenant/modules/accounts/components/form/OpenAccountForm.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'OpenProcedureForm',
  props: {
    beforeClose: { type: Function }
  },
  emits: ["userApproved", "stepFinished"],
  setup(__props: any, { expose: __expose, emit: emits }) {

const props = __props;



const criteria = ref({
  size: 100,
});

const openProcedureFormRef = ref<InstanceType<typeof SimpleForm>>();
const accountDetailRef = ref<InstanceType<typeof AccountDetail>>();
const accountWizardStatus = ref<AccountWizardType | null>(null);
const verificationId = ref<number | undefined>();
const accountRole = ref(AccountRoleTypes.Client);
const applicationDetails = ref<any>(null);
const showRebateCompleteBtn = ref(false);
const verificationDetails = ref<any>({});
const accountDetails = ref<any>(null);
const ibSalesOpeningStep = ref(-1);
const clientOpeningStep = ref(-1);
const isLoading = ref(true);

const getAccountWizardStatus = async () => {
  if (!accountDetails.value) return;
  if (accountWizardStatus.value === null) {
    accountWizardStatus.value = await AccountService.getAccountWizardStatus(
      accountDetails.value.id
    );
  }
  return accountWizardStatus.value;
};

const readOnlyCode = ref<any>(null);
const getReadOnlyCode = async () => {
  if (readOnlyCode.value === null) {
    const res = await AccountService.getTradeAccountReadOnlyCode(
      accountDetails.value.id
    );
    readOnlyCode.value = res.readOnlyCode;
  }
  return readOnlyCode.value;
};



const showAccountDetail = (id: number, _tab = "infos") => {
  accountDetailRef.value?.show(id, _tab, [] as any);
};

const loadAccountApplications = async () => {
  // 下面（comment 掉的部分） application detail 有值，就不用再去查
  // 這樣在審核 application "過程中", 就無法更新到最新的 application 數據 (ex: referenceId 就在過程中更新了)
  try {
    const { data } = await AccountService.queryApplications({
      referenceId: accountDetails.value?.id,
      id: applicationDetails.value?.id,
    });
    applicationDetails.value = data[0];
  } catch (error) {
    console.log(error);
  }

  // if (!applicationDetails.value) {
  //   if (!accountDetails.value) {
  //     MsgPrompt.error("Account details not found");
  //     return;
  //   }
  //   const { data } = await AccountService.queryApplications({
  //     referenceId: accountDetails.value?.id,
  //     id: applicationDetails.value?.id,
  //   });
  //   if (data.length <= 0) {
  //     MsgPrompt.error("Account application not found");
  //     return;
  //   }
  //   applicationDetails.value = data[0];
  // }
  return true;
};

const loadTradeAccountCreate = async () => {
  await loadServices();
  await loadAccountApplications();
  return true;
};

const loadReadOnlyNotice = async () => {
  const wzdStatus = await getAccountWizardStatus();
  if (wzdStatus?.noticeEmailSent) {
    return false;
  }
  return true;
};

const loadKycForm = async () => {
  const wzdStatus = await getAccountWizardStatus();
  if (wzdStatus?.kycFormCompleted) {
    return false;
  }
  return true;
};

const loadPaymentMethod = async () => {
  const wzdStatus = await getAccountWizardStatus();
  if (wzdStatus?.paymentAccessGranted) {
    return false;
  }
};

const partyId = computed<number>(
  () => applicationDetails.value?.partyId ?? accountDetails.value?.partyId
);

const userInfos = ref<any>(null);
const getUserInfos = async () => {
  if (partyId.value && !userInfos.value) {
    userInfos.value = await UserService.getUserInfoByPartyId(partyId.value);
  }
  return userInfos.value;
};

const services = ref<any>(null);

provide(AccountInjectionKeys.APPLICATION_DETAILS, applicationDetails);
provide(AccountInjectionKeys.ACCOUNT_DETAILS, accountDetails);

provide(AccountInjectionKeys.GET_ACCOUNT_WIZARD_STATUS, getAccountWizardStatus);
provide(AccountInjectionKeys.GET_READ_ONLY_CODE, getReadOnlyCode);

provide(AccountInjectionKeys.GET_USER_INFOS, getUserInfos);
provide(AccountInjectionKeys.PLATFORM_SERVICES, services);

// func for application role changed
const roleChanged = (role: AccountRoleTypes) => {
  accountRole.value = role;
  if (
    [
      AccountRoleTypes.IB,
      AccountRoleTypes.Broker,
      AccountRoleTypes.Sales,
    ].includes(role)
  ) {
    ibSalesOpeningStep.value = 1;
  } else {
    clientOpeningStep.value = 1;
  }
};

const loadServices = async () => {
  if (!services.value) {
    services.value = await UserService.getServices();
  }
};

const mountIntoClientStep = async (_step: number) => {
  isLoading.value = true;
  ibSalesOpeningStep.value = -1;

  /**
   * {
   *     "kycFormCompleted": false,
   *     "paymentAccessGranted": false,
   *     "welcomeEmailSent": false,
   *     "noticeEmailSent": false
   * }
   */

  const handleMount =
    {
      1: loadAccountApplications,
      2: loadTradeAccountCreate,
      3: loadReadOnlyNotice,
      4: loadKycForm,
      5: loadPaymentMethod,
      6: loadAccountApplications,
    }[_step] ?? (() => MsgPrompt.error("Mount Error"));

  // await loadUserInfos();
  const wzdStatusOfStep = await handleMount();

  /**
   *  if mounted into step 3 or more, then we need to load user infos & accountDetails
   *  if they are both not loaded, we do not mount into the step
   */
  if (_step >= 3 && !userInfos.value && !accountDetails.value) {
    isLoading.value = false;
    return;
  }

  clientOpeningStep.value = _step;
  await nextTick();

  isLoading.value = false;
};

const mountIntoIbSalesStep = async (_step: number) => {
  isLoading.value = true;
  clientOpeningStep.value = -1;
  const handleMount =
    {
      1: loadAccountApplications,
      3: loadPaymentMethod,
      // 2: loadKycForm,
      4: hide,
    }[_step] ?? (() => MsgPrompt.error("Mount Error"));

  // await loadUserInfos();
  await handleMount();
  ibSalesOpeningStep.value = _step;
  await nextTick();
  isLoading.value = false;
};

const applicationApproved = async (createdAccount: any) => {
  accountDetails.value = createdAccount;
  applicationDetails.value.status = ApplicationStatusType.Approved;
  emits("stepFinished");

  [
    AccountRoleTypes.IB,
    AccountRoleTypes.Broker,
    AccountRoleTypes.Sales,
  ].includes(accountRole.value)
    ? await mountIntoIbSalesStep(3)
    : await mountIntoClientStep(2);
};

const kycFormSubmitted = async () => {
  [
    AccountRoleTypes.IB,
    AccountRoleTypes.Broker,
    AccountRoleTypes.Sales,
  ].includes(accountRole.value)
    ? await mountIntoIbSalesStep(3)
    : await mountIntoClientStep(5);
};

const tradeAccountCreated = async (createdTradeAccount: any) => {
  const res = await AccountService.queryAccounts({
    id: createdTradeAccount.id,
  });
  if (res.data.length <= 0) {
    MsgPrompt.error("No trade account found");
    accountDetails.value.tradeAccount = createdTradeAccount;
  } else {
    accountDetails.value = res.data[0];
  }
  await mountIntoClientStep(3);
};

const showAccountProcedureForm = async (
  mountStep: number,
  mountOptions: {
    selectedVerificationId?: number;
    applicationDetails?: any;
    accountDetails?: any;
  }
) => {
  openProcedureFormRef.value?.show();
  userInfos.value = null;
  showRebateCompleteBtn.value = false;
  accountRole.value =
    mountOptions.accountDetails?.role ??
    mountOptions.applicationDetails?.supplement.role ??
    AccountRoleTypes.Client;

  verificationId.value = mountOptions.selectedVerificationId;
  applicationDetails.value = mountOptions.applicationDetails;
  accountDetails.value = mountOptions.accountDetails;

  if (mountStep === -1) {
    const wizardStatus = await getAccountWizardStatus();
    mountStep =
      [
        { condition: wizardStatus?.welcomeEmailSent, step: 3 },
        { condition: wizardStatus?.noticeEmailSent, step: 4 },
        { condition: wizardStatus?.kycFormCompleted, step: 5 },
        { condition: wizardStatus?.paymentAccessGranted, step: 6 },
      ].find((x) => !x.condition)?.step ?? 3;
  }

  [
    AccountRoleTypes.IB,
    AccountRoleTypes.Broker,
    AccountRoleTypes.Sales,
  ].includes(accountRole.value)
    ? await mountIntoIbSalesStep(mountStep)
    : await mountIntoClientStep(mountStep);
};

const paymentMethodSubmitted = async () => {
  if (
    [
      AccountRoleTypes.IB,
      AccountRoleTypes.Broker,
      AccountRoleTypes.Sales,
    ].includes(accountRole.value)
  ) {
    await mountIntoIbSalesStep(4);
  } else {
    await mountIntoClientStep(6);
  }
};

const hide = () => {
  emits("stepFinished");
  openProcedureFormRef.value?.hide();
};

__expose({
  hide,
  show: showAccountProcedureForm,
});

return (_ctx: any,_cache: any) => {
  const _component_el_step = _resolveComponent("el-step")!
  const _component_el_steps = _resolveComponent("el-steps")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_LoadingRing = _resolveComponent("LoadingRing")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(SimpleForm, {
      ref_key: "openProcedureFormRef",
      ref: openProcedureFormRef,
      title: _ctx.$t('title.accountOpeningProcedure'),
      "is-loading": isLoading.value,
      width: 1000,
      "disable-footer": "",
      "before-close": props.beforeClose,
      style: {}
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            (clientOpeningStep.value > 0 || ibSalesOpeningStep.value > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  (accountRole.value === _unref(AccountRoleTypes).Client)
                    ? (_openBlock(), _createBlock(_component_el_steps, {
                        key: 0,
                        active: clientOpeningStep.value - 1,
                        "align-center": ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_step, {
                            class: "cursor-pointer",
                            title: _ctx.$t('title.accountApplications')
                          }, null, 8, ["title"]),
                          _createVNode(_component_el_step, {
                            class: "cursor-pointer",
                            title: _ctx.$t('action.openMt')
                          }, null, 8, ["title"]),
                          _createVNode(_component_el_step, {
                            class: "cursor-pointer",
                            title: _ctx.$t('tip.readOnlyNotice')
                          }, null, 8, ["title"]),
                          _createVNode(_component_el_step, {
                            class: "cursor-pointer",
                            title: _ctx.$t('tip.kycForm')
                          }, null, 8, ["title"]),
                          _createVNode(_component_el_step, {
                            class: "cursor-pointer",
                            title: _ctx.$t('title.paymentMethod')
                          }, null, 8, ["title"]),
                          _createVNode(_component_el_step, {
                            class: "cursor-pointer",
                            title: _ctx.$t('title.rebate')
                          }, null, 8, ["title"])
                        ]),
                        _: 1
                      }, 8, ["active"]))
                    : (_openBlock(), _createBlock(_component_el_steps, {
                        key: 1,
                        active: ibSalesOpeningStep.value - 1,
                        "align-center": ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_step, {
                            class: "cursor-pointer",
                            title: _ctx.$t('title.accountApplications')
                          }, null, 8, ["title"]),
                          _createVNode(_component_el_step, {
                            class: "cursor-pointer",
                            title: _ctx.$t('title.paymentMethod')
                          }, null, 8, ["title"])
                        ]),
                        _: 1
                      }, 8, ["active"])),
                  _createVNode(_component_el_divider)
                ]))
              : _createCommentVNode("", true),
            (isLoading.value)
              ? (_openBlock(), _createElementBlock("table", _hoisted_4, [
                  _createElementVNode("tbody", null, [
                    _createVNode(_component_LoadingRing)
                  ])
                ]))
              : _createCommentVNode("", true),
            (!isLoading.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createElementVNode("div", null, [
                    (clientOpeningStep.value === 0)
                      ? (_openBlock(), _createBlock(UserDocuments, {
                          key: 0,
                          "verification-details": verificationDetails.value,
                          verifyOperation: true,
                          onUserApproved: hide
                        }, null, 8, ["verification-details"]))
                      : _createCommentVNode("", true),
                    (clientOpeningStep.value === 1 || ibSalesOpeningStep.value === 1)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                          _createVNode(OpenAccountForm, {
                            onApplicationSubmitted: applicationApproved,
                            onRoleChanged: roleChanged,
                            siteId: applicationDetails.value.siteId
                          }, null, 8, ["siteId"])
                        ]))
                      : _createCommentVNode("", true),
                    (clientOpeningStep.value === 2)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                          _createVNode(AccountCreate, {
                            "application-details": applicationDetails.value,
                            accountDetails: accountDetails.value,
                            onAccountSubmitted: tradeAccountCreated
                          }, null, 8, ["application-details", "accountDetails"])
                        ]))
                      : _createCommentVNode("", true),
                    (clientOpeningStep.value === 3)
                      ? (_openBlock(), _createBlock(ReadOnlyNotice, {
                          key: 3,
                          onSubmit: _cache[0] || (_cache[0] = ($event: any) => (clientOpeningStep.value += 1))
                        }))
                      : _createCommentVNode("", true),
                    (clientOpeningStep.value === 4 || ibSalesOpeningStep.value === 2)
                      ? (_openBlock(), _createBlock(KycForm, {
                          key: 4,
                          onSubmit: kycFormSubmitted
                        }))
                      : _createCommentVNode("", true),
                    (clientOpeningStep.value === 5 || ibSalesOpeningStep.value === 3)
                      ? (_openBlock(), _createBlock(PaymentMethodDetailForm, {
                          key: 5,
                          onSubmit: paymentMethodSubmitted,
                          openForm: true
                        }))
                      : _createCommentVNode("", true),
                    (clientOpeningStep.value === 6)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                          _createElementVNode("div", _hoisted_9, [
                            _createElementVNode("table", null, [
                              _createElementVNode("tbody", null, [
                                _createElementVNode("tr", _hoisted_10, [
                                  _createElementVNode("span", {
                                    href: "#",
                                    class: "btn btn-xl btn-light-danger fw-bold",
                                    onClick: _cache[1] || (_cache[1] = ($event: any) => (
                          showAccountDetail(
                            applicationDetails.value.referenceId,
                            'rebate'
                          ),
                            (showRebateCompleteBtn.value = true)
                        ))
                                  }, " Please Edit Rebate Schema ")
                                ]),
                                (showRebateCompleteBtn.value)
                                  ? (_openBlock(), _createElementBlock("tr", _hoisted_11, [
                                      _createElementVNode("span", {
                                        href: "#",
                                        class: "mt-5 btn btn-xl btn-light-success fw-bold",
                                        onClick: _cache[2] || (_cache[2] = ($event: any) => (hide()))
                                      }, " Complete ")
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _: 1
    }, 8, ["title", "is-loading", "before-close"]),
    _createVNode(AccountDetail, {
      ref_key: "accountDetailRef",
      ref: accountDetailRef
    }, null, 512)
  ], 64))
}
}

})